import { createSlice } from "@reduxjs/toolkit";
import {
  getClientsService,
  getClientByIdService,
  updateClientService,
  createClientService,
  getEmployeeService,
  getEmployeeByIdService,
} from "../services/clients_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  clientsList: [],
  metaClient: null,
  clientInfo: null,
  isLoadingAction: false,
  employeesList: [],
  metaEmployee: {},
  employeeInfo: {},
};

const slice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getClientsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsList = action.payload?.data?.data;
        state.metaClient = action.payload.data.meta.meta;
      })
      .addCase(getClientsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getClientsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getClientByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInfo = action.payload?.data?.data;
      })
      .addCase(getClientByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getClientByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createClientService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createClientService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createClientService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(updateClientService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(updateClientService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(updateClientService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(getEmployeeService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employeesList = action.payload?.data?.data;
        state.metaEmployee = action.payload.data.meta.meta;
      })
      .addCase(getEmployeeService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getEmployeeService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getEmployeeByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employeeInfo = action.payload?.data?.data;
      })
      .addCase(getEmployeeByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getEmployeeByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
